import { useState, useEffect, useRef, useCallback } from "react";
//import "datatables.net-dt/js/dataTables.dataTables"
//import "datatables.net-dt/css/jquery.dataTables.min.css"
import { Link } from "react-router-dom";
import { tokenDecode } from "../../utils/helper";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { config } from "../../utils/config";
import Box from '@mui/material/Box';
import { toast } from "react-toastify";
import Modal from '@mui/material/Modal';
import { Modal as AntModal } from "antd"
import { baseUrlDefiner } from "../../utils/config";
import { AnyAaaaRecord } from "dns";
import CloseIcon from '@mui/icons-material/Close';
import { BasicTable } from '../../components/Table';
import { Paginated } from "../../components/Paginated";
import Sellerpagination from "../../components/Paginated/Sellerpagination";
import styles from "./sellerList.module.css"
import '../../components/table.css';
import { saveAs } from "file-saver";
import * as XLSX from 'xlsx';
import shiprocketimg from "../../../src/icons/shiprocket.png"
import { Select, Button, Spin, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import CreateProduct from "../catalog/createProduct"
// import createProduct from "../catalog/createProduct";
const { apiEndpoint, baseNodeapiUrl } = config;



const A = () => <span className="badge badge-primary">New Request</span>
const B = () => <span className="badge badge-success">Approved</span>
const C = () => <span className="badge badge-danger">Blocked</span>
const valueToApp: any = {
    "0": <A />,
    "1": <B />,
    "2": <C />
}
var count = 1;

var $ = require('jquery');
const SellerList = () => {
    const decoded: any = tokenDecode();
    const { data } = decoded;
    const { permission: { category, order, product, role, seller, tax, user } } = data;
    const [sellerList, setSellerList]: any = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [shipmentModalOpen, setshipmentModalOpen] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    // const [checkemail, setCheckemail] = useState<any>()

    // const [Userdata, setUserdata] = useState([]);
    const [Userdata, setUserdata] = useState<{ seller: any } | null>(null);

    const [file, setFile] = useState(null);

    const fetchSellerList = async () => {
        setIsLoading(true);
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/getsellerlist`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                }
            });

            if (data.status === 200) {
                setIsLoading(false);
                setSellerList(data.data);
            }
        } catch (error) {
            console.log("error", error);

            setIsLoading(false);
        }
    }
    const handleImport = async () => {
        try {
            if (file) {
                const reader = new FileReader();
                reader.onload = (e: any) => {
                    const data = e.target.result;
                    const workbook = XLSX.read(data, { type: "array" });
                    const sheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[sheetName];
                    const json = XLSX.utils.sheet_to_json(worksheet);
                    let dataToSend = json.filter((item: any) => item.name !== null)
                    sendDataToDb(dataToSend);

                };
                reader.readAsArrayBuffer(file);
            }

        } catch (error) {
            console.error('Error handling import:', error);
        }
    };
    const { permission: { igm } } = data;
    const showModal = () => {
        setIsModalVisible(true);
    };
    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };


    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState<string>('');

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(search);
        }, 500);
        return () => clearTimeout(timer);
    }, [search]);

    useEffect(() => {
        if (debouncedSearch.trim() === "") {
            fetchSellerList();
        } else {
            searchData(debouncedSearch);
        }
    }, [debouncedSearch]);

    const searchHandler = (e: any) => {
        const value = e.target.value;
        setSearch(value);
        // searchData(value);
    };

    const searchData = async (query: string) => {
        const apiEndpoint = baseUrlDefiner();
        // if (query.trim() === "") {
        //     fetchSellerList();
        //     return;
        // }
        try {
            const result = await axios({
                url: `${apiEndpoint}/seller-filter`,
                method: 'POST',
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                data: {
                    input_data: query,
                },
            });

            console.log("Search Result:", result.data);
            setSellerList(result?.data);
        } catch (error: any) {
            console.error(error?.response?.data?.error?.[0]?.message);
            toast.error(`${error?.response?.data?.error?.[0]?.message} for ${error?.response?.data?.error?.[0]?.email}`);
        }
    };

    async function sendDataToDb(jsonData: any) {
        let apiEndpoint = baseUrlDefiner();
        try {

            let result = await axios({
                url: `${apiEndpoint}/seller_register`,
                method: 'POST',
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                data: jsonData,
            })
            if (result.data.status == 200) {
                toast.success(`Seller Registered successfully!`);
                setFile(null);
                let element: any = document.getElementById('inputFile')
                element.value = ''
            } else {
                console.log(result?.data?.error[0]?.message)
                toast.error(`${result?.data?.error[0]?.message} for ${result?.data?.error[0]?.email}`);
                console.log(result?.data?.error[0]?.message)
                toast.error(`${result?.data?.error[0]?.message} for ${result?.data?.error[0]?.email}`);
            }
        } catch (error: any) {
            console.log(error?.response?.data?.error[0]?.message)
            toast.error(`${error?.response?.data?.error[0]?.message} for ${error?.response?.data?.error[0]?.email}`);
        }
    }

    const [sellerdata, setsellerdata] = useState<{ user: any } | null>(null)
    const [shopdata, setshopdata] = useState<{ shop: any } | null>(null)
    const [businessdata, setbusinessdata] = useState<{ bussiness: any } | null>(null);
    const [servicedata, setservicedata] = useState<{ service: any } | null>(null);



    async function showdata(id: any) {
        let apiEndpoint = baseUrlDefiner();
        try {
            let result = await axios({
                url: `${apiEndpoint}/check_live`,
                method: 'POST',
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                data: {
                    "seller_id": id,
                }
            });
            const data = result?.data?.data;
            if (data && typeof data === "object") {
                setUserdata(data);
                setshopdata(data);
                setbusinessdata(data);
                setservicedata(data);
            }
            if (data && typeof data === "object") {
                setsellerdata(data);
            }
        } catch (error: any) {
            console.log(error?.response?.data?.error?.[0]?.message);
            toast.error(`${error?.response?.data?.error?.[0]?.message} for ${error?.response?.data?.error?.[0]?.email}`);
        }
    }

    const inputHandler = async (e: any) => {

        try {
            var optionvalue = e.target.value;
            console.log(optionvalue);
            if (optionvalue === "pendingseller") {
                const { data } = await axios({
                    url: `${apiEndpoint}/pendingsellerlist`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    }
                });
                console.log("pending data", data.data);
                setIsLoading(false);
                if (data.status === 200) {
                    setSellerList(data.data);


                }
            }
            else if (optionvalue === "approveseller") {
                const { data } = await axios({
                    url: `${apiEndpoint}/approvesellerlist`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    }
                });
                console.log("pending data", data.data);
                setIsLoading(false);
                if (data.status === 200) {
                    setSellerList(data.data);
                }
            }
            else {
                const { data } = await axios({
                    url: `${apiEndpoint}/getsellerlist`,
                    method: "GET",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    }
                });
                console.log("allseller data", data.data);
                const sellerId = data?.data?.seller_id;
                console.log("sellerIdsellerId", sellerId);
                setIsLoading(false);
                if (data.status === 200) {
                    setSellerList(data.data);
                }
            }

        } catch (error) {
            console.log("error", error);

            setIsLoading(false);
        }
    };
    const sellerDelete = async (id: any) => {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/sellerdelete`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: {
                    seller_id: id
                }
            });


            const updateSellerList = sellerList.filter((item: any) => item.id !== id);

            if (data.status === 200) {
                toast.success("Seller Removed Successfully !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
            window.location.reload();

        } catch (error) {
            toast.error("403 error !", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    const Sstyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: "10px",
        bgcolor: 'background.paper',
        border: '1px solid #000',
        boxShadow: 24,
        p: 2,
    };
    const COLUMNS = [
        {
            Header: "Sn No.",
            Footer: "Sn No.",
            accessor: (row: any, count: any) => {
                return <>{count + 1}</>
            },
            disableFilters: true,
            sticky: "left"
        },
        {
            Header: "Company Name",
            Footer: "Company Name",
            accessor: "company_name",
            sticky: "left"
        },
        {
            Header: "Email",
            Footer: "Email",
            accessor: "email",
            sticky: "left"
        },
        {
            Header: "Contact",
            Footer: "Contact",
            accessor: "contact_no",
            sticky: "left"
        },

        {
            Header: "Status",
            Footer: "Status",
            accessor: (row: any) => {
                return <>{valueToApp[row.approve_status]}
                </>
            },
            sticky: "left"
        },
        {
            Header: "Action",
            Footer: "Action",
            accessor: (row: any) => {
                return (
                    <>

                        <div className="d-flex align-items-center">
                            <div>
                                {seller.update ? <Link to={`../../updateseller/${row.id}`} className="btn btn-success btn-circle"> <i className="fas fa-eye"></i></Link> : null}{seller.delete ? <button className="btn btn-danger btn-circle d-none" onClick={() => sellerDelete(row.id)}><i className="fas fa-trash"></i></button> : null}
                            </div>



                            <div>
                                <span className="badge badge-secondary" style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        let url = `https://adminsr.thesellerapp.com/?navigateToSeller=true&token=${sessionStorage.getItem("us_st_d")}&provider_id=${row.provider_id}&email=${row.email}`
                                        window.open(url, "_blank", "width=800,height=800,noopener,noreferrer");
                                        // setCheckemail(row.email)

                                    }}
                                >Log In</span>

                            </div>
                        </div>
                    </>
                )

            },
            sticky: "left"
        },

        {
            Header: "check live",
            Footer: "check live",
            accessor: (row: any) => {
                return (
                    <>
                        <div className="col-md-12 mb-2 d-flex flex-nowrap justify-content-between">
                            <button
                                type="button"
                                onClick={() => {
                                    showModal();
                                    showdata(row?.seller_id);
                                }}

                                className="btn btn-success"
                            >
                                View
                            </button>

                        </div>

                    </>
                )
            },

            sticky: "left"
        },

    ];
    count++

    useEffect(() => {
        fetchSellerList();
    }, [])
    function handleShipementModalClose() {
        setshipmentModalOpen(false)
    }

    function getSampleExcelFile() {
        const data = [
            {

                company_name: "Company A",
                name: "John Doe",
                email: "john.doe@example.com",
                image: { shiprocketimg },
                contact_no: "1234567890",
                customer_care_contact: "9876543210",
                pan_name: "Company A Pvt. Ltd.",
                pan_no: "ABCDE1234F",
                gst_no: "GSTIN1234567",
                personal_address: "123, Main Street",
                street: "Main Street",
                locality: "Downtown",
                city: "Cityville",
                state: "State A",
                area_code: "12345",
                seller_city_code: "",
                fssai_licence: "FSSAI1234567890",
                latitude: "12.3456",
                longitude: "78.9101",
                bank_account: "12345678901234",

                ifsc_code: "ABCD0123456",
                beneficiary_name: "John Doe",
                bank_name: "Bank of Example",
                branch_name: "Main Branch",
                radius: "10",
                ondc_commission: "5",
                short_description: "Short description of products",
                description: "Detailed description of products",
                opening_days: "1,2,3,4,5,6,7",
                closing_days: "",
                opening_time: "00:00",
                closing_time: "23:59",
                returnable: false,
                replaceable: false,
                cancelable: false,
                return_window: "P2D",
                seller_pickup_return: false,
                time_to_ship: "P2D",
                address_proof_type: "Aadhar Card",
                gst_registered_address: "Same as personal address",
                cod: false,
                delivery_fee: "0",
                packing_fee: "0",
                holidays: "",
                service_city_code: "",
                ondc_domain: "",
                service_type: "",
                service_range: "",
                service_city: ""
            }
        ];

        const headers = Object.keys(data[0]);

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data, { header: headers });

        XLSX.utils.book_append_sheet(wb, ws, 'Orders');

        const fileName = `Sample_Seller_${new Date().getTime()}.xlsx`;

        XLSX.writeFile(wb, fileName);

    }

    const fetchAndDownload = async () => {
        let apiEndpoint = baseUrlDefiner();

        try {
            const result = await axios({
                url: `${apiEndpoint}/sellerexport`,
                method: 'POST',
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                    'Accept': 'application/json'
                },
            });


            const data = result.data?.response;
            const filteredData = data.map((item: any) => ({
                "ID": item.id,
                "Company Name": item.company_name,
                "PAN Name": item.pan_name,
                "PAN Number": item.pan_no,
                "PAN Image": item.pan_image,
                "GST Number": item.gst_no,
                "Contact Number": item.contact_no,
                "Street": item.street,
                "City": item.city,
                "Area Code": item.area_code,
                "State": item.state,
                "Latitude": item.latitude,
                "Longitude": item.longitude,
                "Provider ID": item.provider_id,
                "Personal Address": item.personal_address,
                "Address Proof Type": item.address_proof_type,
                "Address Proof Image": item.address_proof_image,
                "UPI Address": item.upi_address,
                "Bank Account": item.bank_account,
                "IFSC Code": item.ifsc_code,
                "Beneficiary Name": item.beneficiary_name,
                "Bank Name": item.bank_name,
                "Branch Name": item.branch_name,
                "Status": item.status,
                "Approve Status": item.approve_status,
                "Short Description": item.short_description,
                "Description": item.description,
                "Seller Source": item.seller_source,
                "City Code": item.city_code,
                "Token": item.token,
                "Locality": item.locality,
                "Radius": item.radius,
                "GST Image": item.gst_image,
                "GST Registered Address": item.gst_registered_address,
                "Cancelled Cheque Image": item.cancelled_cheque_image,
                "Trade Licence Number": item.trade_licence_number,
                "W Stepcount": item.w_stepcount,
                "Created At": item.created_at,
                "Updated At": item.updated_at,
                "Name": item.name,
                "Email": item.email,
                "Password": item.password,
                "Seller ID": item.seller_id,
                "Parent ID": item.parent_id,
                "Role ID": item.role_id,
                "Display Email": item.display_email,
                "Opening Days": item.opening_days,
                "Closing Days": item.closing_days,
                "Opening Time": item.opening_time,
                "Closing Time": item.closing_time,
                "Returnable": item.returnable,
                "Replaceable": item.replaceable,
                "Customer Care Contact": item.customer_care_contact,
                "Cancelable": item.cancelable,
                "Return Window": item.return_window,
                "Seller Pickup Return": item.seller_pickup_return,
                "Time To Ship": item.time_to_ship,
                "COD": item.cod,
                "Incorporation Date": item.incorporation_date,
                "Images": item.images,
                "Commission": item.commission,
                "ONDC Commission": item.ondc_commission,
                "FSSAI Licence": item.fssai_licence,
                "Seller Commission": item.seller_commission,
                "Delivery Fee": item.delivery_fee,
                "Packing Fee": item.packing_fee,
                "Holidays": item.holidays,
                "FSSAI Licence Image": item.fssai_licence_image,
                "Notification": item.notification,
                "Minimum Amount": item.min_amount,
                "Notify Email": item.notify_email,
                "Service Type": item.service_type,
                "Service Type Code": item.service_type_code,
                "Service Range": item.service_range,
                "Service City": item.service_city,
                "ONDC Domain": item.ondc_domain
            }));

            const worksheet = XLSX.utils.json_to_sheet(filteredData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sellers");
            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });
            const blob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Seller_List.xlsx");
            console.log("Excel file downloaded successfully.");
        } catch (error) {
            if (axios.isAxiosError(error)) {
                console.error("Error Response:", error.response?.data);
            } else {
                console.error("Unknown Error:", error);
            }
        }
    };



    const [modalVisible, setModalVisible] = useState(false);
    const [bapId, setBapId] = useState("");
    const [domain, setDomain] = useState("");
    const [loading, setLoading] = useState(false);
    const [responseData, setResponseData] = useState(null);
    const [selectedSellerId, setSelectedSellerId] = useState<number | null>(null);

    console.log("sellerListsellerListsellerList", sellerList)
    // Dropdown data
    const bapIds = [
        "prd.mystore.in",
        "vishopondc.myvi.in",
        "ondc.nlincs.in",
        "moyto.eazehub.com",
        "api.sahajbazaar.in",
        "sabhyasha.eazehub.com",
        "buysimplynow.eazehub.com",
        "mappls.com",
        "bharatham-backend.bharath.am",
        "prod.nirmitbap.ondc.org"
    ];

    const domains = [
        { name: "Grocery", value: "ONDC:RET10" },
        { name: "Fashion", value: "ONDC:RET12" },
        { name: "BPC", value: "ONDC:RET13" },
        { name: "Electronics", value: "ONDC:RET14" },
        { name: "Appliances", value: "ONDC:RET15" },
        { name: "Home & Kitchen", value: "ONDC:RET16" },
        { name: "Health & Wellness", value: "ONDC:RET18" },
    ];

    const handleSearch = async () => {
        if (!bapId || !domain) {
            message.warning("Please select both BAP ID and Domain.");
            return;
        }

        setLoading(true);
        setResponseData(null);

        try {
            const now = new Date();
            const startDate = new Date(now.setHours(0, 1, 0, 0)).toISOString();
            const endDate = new Date(now.setHours(23, 59, 59, 999)).toISOString();

            const body = {
                start_time: startDate,
                end_time: endDate,
                domain,
                seller_id: selectedSellerId, // send selected seller id
                bap_id: bapId,
            };

            console.log("📤 Request:", body);

            const response = await fetch(
                `${baseNodeapiUrl}/shiprocket/incremental_search`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(body),
                }
            );

            const data = await response.json();
            setResponseData(data);
            message.success("Data fetched successfully!");
        } catch (error) {
            console.error("❌ Error:", error);
            message.error("Failed to fetch incremental data!");
        } finally {
            setLoading(false);
        }
    };

    const handleIncrementalCancel = () => {
        setModalVisible(false);
        setResponseData(null);
        setBapId("");
        setDomain("");
    };



    return (
        <>

            <ThemeMaker>





                <>
                    <Modal
                        open={shipmentModalOpen}
                        // onClose={handleShipementModalClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={Sstyle} className="col-md-4 w-100 w-md-25">

                            <div className="modal-content ">
                                <div className="modal-header p-2 d-flex align-items-center justify-content-between">
                                    <p className="modal-title genericlabel d-flex justify-content-between w-100" style={{ letterSpacing: "1px" }}> <span>   </span>  <a onClick={() => { getSampleExcelFile() }} style={{ cursor: "pointer" }} >Download Sample Excel</a> </p>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span style={{ cursor: "pointer" }} ><CloseIcon onClick={handleShipementModalClose} /></span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="importingSection">
                                        <input type="file" id="inputFile" onChange={(e) => {
                                            const file: any = e.target.files && e.target.files.length > 0 ? e.target.files[0] : null;
                                            setFile(file);
                                        }}
                                            style={{ marginTop: "30px" }}
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-primary" onClick={handleImport} > Submit </button>
                                </div>
                            </div>
                        </Box>
                    </Modal>

                </>
                <div className="row w-100 m-0 mt-1">
                    <div className="col-md-12 ">
                        <div className="card shadow mb-4">

                            <div className="card-header py-3 d-flex flex-column flex-lg-row justify-content-between">

                                <div className="flex">
                                    <div>
                                        <h6 className="m-0 font-weight-bold  text-left">
                                            Search By
                                        </h6>
                                    </div>
                                    <div>
                                        <input type="text" value={search} onChange={searchHandler}
                                            className="border border-gray-300 rounded px-2 py-1"
                                            placeholder="search seller..." />
                                    </div>
                                </div>
                                <div className={styles.sellerListOptions}> <b>Filter By: </b><select name="status" id="" onChange={(e: any) => inputHandler(e)}>
                                    <option value="allseller" selected >All</option>
                                    <option value="pendingseller">Pending Seller</option>
                                    <option value="approveseller">Approved Seller</option>
                                </select>
                                </div>
                                <>
                                    {/* Main trigger button */}
                                    <div className="">
                                        <Button
                                            type="primary"
                                            icon={<SearchOutlined />}
                                            className="btn btn-primary"
                                            onClick={() => setModalVisible(true)}
                                            style={{
                                                backgroundColor: "#1e88e5",
                                                borderRadius: "6px",
                                                fontWeight: 500,
                                                boxShadow: "0 2px 6px rgba(30,136,229,0.3)",
                                                marginTop: "5px",
                                            }}
                                        >
                                            Incremental Search
                                        </Button>
                                    </div>

                                    {/* Your existing custom modal */}
                                    <AntModal
                                        className="custom-left-modal "
                                        open={modalVisible}
                                        onOk={handleSearch}
                                        onCancel={handleIncrementalCancel}
                                        width={400}
                                        okText="Run Search"
                                        cancelText="Close"
                                    >
                                        <div style={{ padding: "10px 0" }}>
                                            <h5 style={{ color: "#1e88e5", fontWeight: 600, marginBottom: 10 }}>
                                                Incremental Search
                                            </h5>

                                            {/* BAP ID Dropdown */}
                                            <div style={{ marginBottom: 16 }}>
                                                <label style={{ fontWeight: 500 }}>Select BAP ID:</label>
                                                <Select
                                                    placeholder="Choose BAP ID"
                                                    style={{ width: "100%", marginTop: 6 }}
                                                    value={bapId || undefined}
                                                    onChange={(value) => setBapId(value)}
                                                    showSearch
                                                    optionFilterProp="label"
                                                    options={bapIds.map((id) => ({ label: id, value: id }))}
                                                ></Select>
                                            </div>

                                            {/* Domain Dropdown */}
                                            <div style={{ marginBottom: 16 }}>
                                                <label style={{ fontWeight: 500 }}>Select Domain:</label>
                                                <Select
                                                    placeholder="Choose Domain"
                                                    style={{ width: "100%", marginTop: 6 }}
                                                    value={domain || undefined}
                                                    onChange={(value) => setDomain(value)}
                                                    options={domains.map((d) => ({
                                                        label: `${d.name} (${d.value})`,
                                                        value: d.value,
                                                    }))}
                                                />
                                            </div>
                                            {/* Seller Dropdown */}
                                            <div style={{ marginBottom: 16 }}>
                                                <label style={{ fontWeight: 500 }}>Select Seller:</label>
                                                <Select
                                                    placeholder="Choose Seller"
                                                    style={{ width: "100%", marginTop: 6 }}
                                                    value={selectedSellerId || undefined} // state for selected seller
                                                    onChange={(value) => setSelectedSellerId(value)} // value will be seller_id
                                                    showSearch
                                                    optionFilterProp="label"
                                                    options={sellerList.map((seller: any) => ({
                                                        label: seller.company_name,   // what user sees
                                                        value: seller.seller_id, // what will be sent
                                                    }))}
                                                />
                                            </div>


                                            {/* Loading spinner */}
                                            {loading && (
                                                <div style={{ textAlign: "center", padding: "12px" }}>
                                                    <Spin size="large" />
                                                </div>
                                            )}


                                        </div>
                                    </AntModal>
                                </>
                            </div>



                            <div className="d-flex justify-content-end m-2">
                                <span className="text-center mx-2" style={{ background: "lightgrey", borderRadius: "12px", fontSize: "14px", width: "150px", color: "black", fontWeight: "600", height: "27px", cursor: "pointer", paddingTop: "3px" }}
                                    onClick={fetchAndDownload}
                                >Export Seller</span>



                                <span className="text-center" style={{ background: "lightgrey", borderRadius: "12px", fontSize: "14px", width: "150px", color: "black", fontWeight: "600", height: "27px", cursor: "pointer", paddingTop: "3px" }}
                                    onClick={() => {
                                        setshipmentModalOpen(true)
                                    }}
                                >Import Sellers</span>

                            </div>

                            <div className={`card-body p-0 ${styles.cardbody}`}>
                                <div className="table table-responsive ">
                                    <div className={styles.sellerListing_desktop} >
                                        <Paginated data={sellerList} columns={COLUMNS} />
                                    </div>
                                    <div className={styles.sellerListing_mobile}>
                                        <Sellerpagination itemsPerPage={20} items={sellerList} sellerDelete={sellerDelete} paginationFor="seller"></Sellerpagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <AntModal
                    className="custom-left-modal"

                    open={isModalVisible}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    width={860}
                    mask={false}

                >
                    <div className="row">
                        <div className="col">
                            <h2 className="text-2xl mb-4"> Seller</h2>
                            <div className="max-h-[500px] overflow-y-auto border border-gray-300 rounded-md p-2">
                                <table className="tableAlignment table-auto w-full border border-gray-300 mt-4">
                                    <thead>
                                        <tr className="bg-gray-100 text-left">
                                            <th className="px-4 py-2 border">Field</th>
                                            <th className="px-4 py-2 border">Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr><td className="border px-4 py-2">Company Name</td><td className="border px-4 py-2">{Userdata?.seller?.company_name}</td></tr>
                                        <tr><td className="border px-4 py-2">GST No</td><td className="border px-4 py-2">{Userdata?.seller?.gst_no}</td></tr>
                                        <tr><td className="border px-4 py-2">PAN No</td><td className="border px-4 py-2">{Userdata?.seller?.pan_no}</td></tr>
                                        <tr><td className="border px-4 py-2">Contact No</td><td className="border px-4 py-2">{Userdata?.seller?.contact_no}</td></tr>
                                        <tr><td className="border px-4 py-2">Street</td><td className="border px-4 py-2">{Userdata?.seller?.street}</td></tr>
                                        <tr><td className="border px-4 py-2">City</td><td className="border px-4 py-2">{Userdata?.seller?.city}</td></tr>
                                        <tr><td className="border px-4 py-2">Area Code</td><td className="border px-4 py-2">{Userdata?.seller?.area_code}</td></tr>
                                        <tr><td className="border px-4 py-2">State</td><td className="border px-4 py-2">{Userdata?.seller?.state}</td></tr>
                                        <tr><td className="border px-4 py-2">Latitude</td><td className="border px-4 py-2">{Userdata?.seller?.latitude}</td></tr>
                                        <tr><td className="border px-4 py-2">Longitude</td><td className="border px-4 py-2">{Userdata?.seller?.longitude}</td></tr>
                                        <tr><td className="border px-4 py-2">Provider ID</td><td className="border px-4 py-2">{Userdata?.seller?.provider_id}</td></tr>
                                        <tr><td className="border px-4 py-2">Bank Account</td><td className="border px-4 py-2">{Userdata?.seller?.bank_account}</td></tr>
                                        <tr><td className="border px-4 py-2">IFSC Code</td><td className="border px-4 py-2">{Userdata?.seller?.ifsc_code}</td></tr>
                                        <tr><td className="border px-4 py-2">Beneficiary Name</td><td className="border px-4 py-2">{Userdata?.seller?.beneficiary_name}</td></tr>
                                        <tr><td className="border px-4 py-2">Bank Name</td><td className="border px-4 py-2">{Userdata?.seller?.bank_name}</td></tr>
                                        <tr><td className="border px-4 py-2">Branch Name</td><td className="border px-4 py-2">{Userdata?.seller?.branch_name}</td></tr>
                                        <tr><td className="border px-4 py-2">Status</td><td className="border px-4 py-2">{Userdata?.seller?.status ? 'Active' : 'Inactive'}</td></tr>
                                        <tr><td className="border px-4 py-2">Approve Status</td><td className="border px-4 py-2">{Userdata?.seller?.approve_status === 1 ? 'Approved' : 'Not Approved'}</td></tr>
                                        <tr><td className="border px-4 py-2">Short Description</td><td className="border px-4 py-2">{Userdata?.seller?.short_description}</td></tr>
                                        <tr><td className="border px-4 py-2">Description</td><td className="border px-4 py-2">{Userdata?.seller?.description}</td></tr>
                                        <tr><td className="border px-4 py-2">City Code</td><td className="border px-4 py-2">{Userdata?.seller?.city_code}</td></tr>
                                        <tr><td className="border px-4 py-2">Locality</td><td className="border px-4 py-2">{Userdata?.seller?.locality}</td></tr>
                                        <tr><td className="border px-4 py-2">Radius</td><td className="border px-4 py-2">{Userdata?.seller?.radius} meters</td></tr>

                                    </tbody>
                                </table>
                                <h2 className=" text-2xl font-semibold mb-4"> User</h2>
                                <table className="tableAlignment table-auto w-full border border-gray-300 mt-4">

                                    <tbody>
                                        <tr>
                                            <td className="border px-4 py-2">Name</td>
                                            <td className="border px-4 py-2">{sellerdata?.user?.name}</td>
                                        </tr>

                                        <tr>
                                            <td className="border px-4 py-2">Email</td>
                                            <td className="border px-4 py-2">{sellerdata?.user?.email}</td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">Contact No</td>
                                            <td className="border px-4 py-2">{sellerdata?.user?.contact_no}</td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">Status</td>
                                            <td className="border px-4 py-2">
                                                {Userdata?.seller?.status ? "Active" : "Inactive"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">Approve Status</td>
                                            <td className="border px-4 py-2">
                                                {Userdata?.seller?.approve_status === 1 ? "Approved" : "Not Approved"}
                                            </td>
                                        </tr>
                                    </tbody>

                                </table>
                                <h2 className="text-2xl font-semibold mb-4"> Shop</h2>
                                <table className="tableAlignment table-auto w-full border border-gray-300 mt-4">

                                    <tbody>
                                        <tr>
                                            <td className="border px-4 py-2">opening_days</td>
                                            <td className="border px-4 py-2">{shopdata?.shop?.opening_days}</td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">opening_time</td>
                                            <td className="border px-4 py-2">{shopdata?.shop?.opening_time}</td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">closing_time</td>
                                            <td className="border px-4 py-2">{shopdata?.shop?.closing_time}</td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">returnable</td>
                                            <td className="border px-4 py-2">{shopdata?.shop?.returnable ? 'Yes' : 'No'}</td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">replaceable</td>
                                            <td className="border px-4 py-2">{shopdata?.shop?.replaceable ? 'Yes' : 'No'}</td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">customer_care_contact</td>
                                            <td className="border px-4 py-2">{shopdata?.shop?.customer_care_contact}</td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">cancelable</td>
                                            <td className="border px-4 py-2">{shopdata?.shop?.cancelable ? 'Yes' : 'No'}</td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">return_window</td>
                                            <td className="border px-4 py-2">{shopdata?.shop?.return_window}</td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">seller_pickup_return</td>
                                            <td className="border px-4 py-2">{shopdata?.shop?.seller_pickup_return ? 'Yes' : 'No'}</td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">time_to_ship</td>
                                            <td className="border px-4 py-2">{shopdata?.shop?.time_to_ship}</td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">cod</td>
                                            <td className="border px-4 py-2">{shopdata?.shop?.cod ? 'Yes' : 'No'}</td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">images</td>
                                            <td className="border px-4 py-2">
                                                <img src={shopdata?.shop?.images} alt="Seller Logo" style={{ width: "80px", height: "80px" }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">ondc_commission</td>
                                            <td className="border px-4 py-2">{shopdata?.shop?.ondc_commission}</td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">fssai_licence</td>
                                            <td className="border px-4 py-2">{shopdata?.shop?.fssai_licence}</td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">status</td>
                                            <td className="border px-4 py-2">{shopdata?.shop?.status ? 'Active' : 'Inactive'}</td>
                                        </tr>

                                    </tbody>


                                </table>


                                <h2 className="text-2xl font-semibold mb-4"> Service</h2>
                                <table className="tableAlignment table-auto w-full border border-gray-300 mt-4">

                                    <tbody>

                                        <tr>
                                            <td className="border px-4 py-2">service_type</td>
                                            <td className="border px-4 py-2">
                                                {servicedata?.service?.service_type || "N/A"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">service_type_code</td>
                                            <td className="border px-4 py-2">
                                                {servicedata?.service?.service_type_code !== undefined && Userdata?.seller?.service_type_code !== null
                                                    ? servicedata?.service?.service_type_code
                                                    : "N/A"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">service_range</td>
                                            <td className="border px-4 py-2">
                                                {servicedata?.service?.service_range || "N/A"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2">service_city</td>
                                            <td className="border px-4 py-2">
                                                {servicedata?.service?.service_city || "N/A"}
                                            </td>
                                        </tr>
                                    </tbody>



                                </table>


                                <h2 className="text-2xl font-semibold mb-4"> Bussiness</h2>
                                <table className="tableAlignment table-auto w-full border border-gray-300 mt-4">

                                    <tbody>

                                        <tr>
                                            <td className="border px-4 py-2">bussiness</td>
                                            <td className="border px-4 py-2">
                                                {businessdata && Array.isArray(businessdata.bussiness) && businessdata.bussiness.length > 0
                                                    ? businessdata.bussiness.join(", ")
                                                    : "N/A"}
                                            </td>



                                        </tr>


                                    </tbody>


                                </table>


                            </div>
                        </div>
                    </div>
                    {/* <createProduct data={sellerList} /> */}
                </AntModal>
            </ThemeMaker>
            {/* <div style={{ display: "none" }}>
                <CreateProduct checkemail={checkemail} />
            </div> */}

        </>
    )
}

export default SellerList;